import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, MenuController } from 'ionic-angular';
import { GlobalProvider } from '../../providers/global/global';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { DetailPage } from '../detail/detail';

@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage {

  data: Observable<any>;
  index: number;

  constructor(public navCtrl: NavController, public navParams: NavParams, public menuCtrl: MenuController, public global: GlobalProvider, public http: HttpClient) {

    this.menuCtrl.enable(true, 'myMenu');
  }

  ionViewDidLoad() {
    
  }

  
}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts